/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsContainer_item = {
    readonly isSold: boolean | null;
    readonly " $refType": "PdpRespSimilarItemsContainer_item";
};
export type PdpRespSimilarItemsContainer_item$data = PdpRespSimilarItemsContainer_item;
export type PdpRespSimilarItemsContainer_item$key = {
    readonly " $data"?: PdpRespSimilarItemsContainer_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsContainer_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'aaaa456bf1eb6838b06746d370991efb';
export default node;
